// @ts-ignore
import React, { useCallback } from "react";
import { gql, useQuery } from "@apollo/client";
import {
  SearchOffersQueryQuery,
  SearchOffersQueryQueryVariables,
  Offer
} from "../../../schemaTypes";
import { newOfferSubscription } from "../FindOffers";

export const searchOffersQuery = gql`
  query SearchOffersQuery(
    $input: SearchOffersInput
    $offset: Int!
    $limit: Int!
  ) {
    searchOffers(
      input: $input, 
      offset: $offset, 
      limit: $limit
    ) {
      id
      title
      description
      bannerUrl
      category {
        id
        name
        imgSrc
        createdAt
        # updatedAt
      }
      offerType
      status
      # discountType
      # discountValue
      # partnerVoucher
      # referralUrl
      offerTOR
      startDate
      endDate
      # community{
      #   id
      #   name
      #   alias
      # }
      # location{
      #   id
      #   city
      # }
      createdBy{
        id
        admin {
          id
          merchantProfile {
            id
            # address
            # city
            # country
            # postcode
            companyName
            username
            # industry {
            #   id
            #   name
            # }
            companyLocation
            logoUrl
            bannerUrl
            description
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`;

newOfferSubscription;

export interface WithSearchOffers {
  offers: Offer[];
  loading: boolean;
  loadMore: () => void;
  hasMoreOffers: boolean;
  subscribe: () => void;
}

interface Props {
  variables:   SearchOffersQueryQueryVariables;
  children: (data: WithSearchOffers) => React.ReactElement | null;
}

export const SearchOffers: React.FC<Props> = ({ children, variables }) => {
  const { data, loading, fetchMore, subscribeToMore } = useQuery<
    SearchOffersQueryQuery,
    SearchOffersQueryQueryVariables
  >(searchOffersQuery, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  let offers: Offer[] = [];
  if (data && data.searchOffers) {
    offers = data.searchOffers as Offer[];
  }

  let hasMoreOffers = offers.length % variables.limit === 0;
  if (offers.length <= variables.offset) {
    hasMoreOffers = false;
  }

  const loadMore = useCallback(() => {
    fetchMore({
      variables: {
        ...variables,
        offset: offers.length
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return prev;
        }
        return {
          ...prev,
          searchOffers: [
            ...prev.searchOffers,
            ...fetchMoreResult.searchOffers
          ]
        };
      }
    });
  }, [fetchMore, variables, offers.length]);

  // Subscription for new offers
  const subscribe = useCallback(() => {
    subscribeToMore({
      document: newOfferSubscription,
      variables: { variables },
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) {
          return prev;
        }
        return {
          ...prev,
          searchOffers: [
            ...prev.searchOffers,
            (subscriptionData.data as any).newOffer
          ]
        };
      }
    });
  }, [subscribeToMore, variables]);

  return children({
    hasMoreOffers,
    offers,
    loading,
    loadMore,
    subscribe,
  });
};